module.exports = __webpack_public_path__ + "img/expblock.4edb9ee0.svg";